// src/app/crumb-name.ts
// The name the top bar's last crumb shows on the encounter route, set by the encounter page once the patient resolves.
// The route carries the appointment, not the patient, and a reload or deep link has no tap-time navigation state, so
// the crumb read "Patient" (Antonin, 15 Oct: the last crumb is the patient's name). A tiny external store: no fetch of
// its own, nothing the page does not already hold.
import { useSyncExternalStore } from 'react';

let name: string | null = null;
const listeners = new Set<() => void>();

export function setCrumbName(next: string | null): void {
  if (next === name) return;
  name = next;
  listeners.forEach((l) => l());
}

export function useCrumbName(): string | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => {
        listeners.delete(l);
      };
    },
    () => name,
    () => null,
  );
}
